import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import getEnvironDomain from 'utils/getEnvironDomain';
import isMobile from 'ati-utils/isMobile';
import { useStores } from 'hooks/useStores';
import Popover from 'ati-ui-react/components/Popover';
import Link from 'ati-ui-react/components/Link';
import useWindowSize from 'hooks/useWindowSize';
import { addMetric } from 'utils/addMetrics';
import stringifyPrice from 'utils/stringifyNumber';
import isEmpty from 'lodash/isEmpty';

import { QuoteDataContainer } from './QuoteDataStyles';

const QuoteData: FC = observer(() => {
  const [width] = useWindowSize();
  const location = useLocation();

  const {
    advertsStore: {
      // TODO типизировать, как будет готов стор
      // @ts-ignore
      currentAdvert: { quote_data, is_owner, price },
    },
    loginContactInfoStore: { loginContactInfo, isLogin, getLoginContactInfo },
  } = useStores();

  const showLeasingBadge = !(isEmpty(quote_data) || is_owner);

  useEffect(() => {
    getLoginContactInfo();
    if (showLeasingBadge) {
      addMetric('lizing-block-show-on-card');
    }
  }, []);

  if (!showLeasingBadge) return null;

  const ctrlLandingUrl = '//lp.ctrl.lc/atisu';
  const atiUtmSource = 'ati_button';

  const formatCurrency = stringifyPrice(quote_data.monthly_payment.value);
  const url = `https://tm.${getEnvironDomain()}${location.pathname}`;
  const baseDetailsUrl = `${ctrlLandingUrl}?utm_source=${atiUtmSource}&price=${price}&url=${url}`;

  const phoneNumber = loginContactInfo.mobile || loginContactInfo.phone;
  const phoneNumberNormalized = phoneNumber && phoneNumber.replace(/\D/g, '');
  const isMobileExist = !isEmpty(phoneNumber) ? `&mobile=+${phoneNumberNormalized}` : '';
  const isEmailExist = !isEmpty(loginContactInfo.e_mail) ? `&email=${loginContactInfo.e_mail}` : '';

  const uri =
    `${ctrlLandingUrl}?utm_source=${atiUtmSource}&price=${price}` +
    `&name=${loginContactInfo.name}${isMobileExist}${isEmailExist}&url=${url}`;
  const encoded = encodeURI(uri);
  const link = isLogin ? encoded : baseDetailsUrl;

  const onHandleShowPopover = (e: React.SyntheticEvent): void => {
    e.stopPropagation();
    addMetric('lizing-bar-info-popover');
  };

  const onHandleMoreDetails = (e: React.SyntheticEvent): void => {
    e.stopPropagation();
    addMetric('lizing-bar-click');

    window.open(link, '_blank');
  };

  return (
    <QuoteDataContainer isTouchScreen={!isMobile()}>
      <span onClick={onHandleMoreDetails} className="format-currency">
        {formatCurrency} руб. x 48 мес. Аванс от 0%
      </span>
      <Popover
        mainText={
          <span className="main-text">
            Лизинг техники с пробегом на выгодных условиях от партнера АТИ.
          </span>
        }
        additionalText={
          <Link
            href={`https://${getEnvironDomain()}/Partners/Info.aspx?PartnerService=CtrlLeasing`}
            type="external"
            rel="noopener noreferrer"
            target="_blank"
          >
            Подробнее
          </Link>
        }
        place="bottom"
        enableAdaptive
        matchMedia="max-width: 200px"
        closeOnOverlayClick
        className="quote-data-popup"
      >
        <span role="presentation" onClick={onHandleShowPopover} className="open-popup">
          {width > 360 ? <span>CTRL&nbsp;Лизинг</span> : '?'}
        </span>
      </Popover>
    </QuoteDataContainer>
  );
});

export default QuoteData;
